import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Dashboard from "./screens/Dashboard";
import SuppliersListScreen from "./screens/Suppliers/SuppliersListScreen";
import Supplier from "./screens/Suppliers/SupplierScreen";
import StaffListScreen from "./screens/staff/StaffListScreen";
import StaffScreen from "./screens/staff/StaffScreen";
import ProductScreen from "./screens/products/productScreen.jsx";
import "./App.css";
import { useAuth } from "./context/AuthContext";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import SignIn from "./screens/SignIn/SignIn";
import AuthProvider from "./context/AuthProvider";
import Fertilizers from "./screens/Fertilizer/fertilizers.jsx";
import CategoryScreen from "./screens/Categories/CategoryScreen.jsx";
import ProductsListScreen from "./screens/products/ProductsListScreen.jsx";
import CustomerTypes from "./screens/CustomerTypes/CustomerTypes.jsx";
import CustomersListScreen from "./screens/Customers/CustomersListScreen.jsx";
import CustomerScreen from "./screens/Customers/CustomerScreen.jsx";
import Unauthorized from "./screens/Unauthorized"; // Create this page
import Expense from "./screens/Expense/Expense.jsx";
import StaffProfileScreen from "./screens/staff/StaffProfileScreen.jsx";
import StaffAddUpdate from "./screens/staff/StaffAddOrUpdate.jsx";
import Home from "./screens/Home";
// transactions
import PurchasesScreen from "./screens/transactions/Purchases/PurchasesListScreen.jsx";
import PurchaseView from './screens/transactions/Purchases/PurchaseView.jsx';
import SalesScreen from './screens/transactions/Sales/SalesListScreen.jsx';
import SaleView from './screens/transactions/Sales/SaleView.jsx';
import CustomerPaymentsDashboard from './screens/transactions/CustomerPayments/CustomerPaymentsList.jsx';
import SupplierPaymentsDashboard from './screens/transactions/supplier_payment/SupplierPaymentsList.jsx';
import FertilizationTransactions from './screens/transactions/fertilization/fertilizationProcess.jsx';
import ExpensesTransactions from "./screens/transactions/ExpensesTransactions/ExpensesTransactions.jsx";
import DamagesTransactions from "./screens/transactions/Damages/DamagesTransactions.jsx";
import DamageView from "./screens/transactions/Damages/DamageView.jsx";
import CashHandoversTransactions from "./screens/transactions/CashHandovers/CashHandoversTransactions.jsx";
import ExpenseReport from "./screens/Reports/ExpenseReport.jsx";
import CashHandoverReport from "./screens/Reports/CashhandoverReport.jsx";
import FundSummaryReport from "./screens/Reports/FundSummaryReport.jsx";
import InventorySummaryReport from "./screens/Reports/InventorySummaryReport.jsx";
import FertilizationsReport from "./screens/Reports/FertilizationsReport.jsx";
import FertilizingDateReport from "./screens/Reports/FertilizingDateReport.jsx";
import MostSoldReport from "./screens/Reports/MostSoldReport.jsx";
import SuppliersAnalysisReport from "./screens/Reports/SuppliersAnalysisReport.jsx";
import DiscountsSavingsReport from "./screens/Reports/DiscountsSavingsReport.jsx";
import MostFrequentCustomersReport from "./screens/Reports/MostFrequentCustomersReport.jsx";
import PurchasesReport from "./screens/Reports/sales & purchases/PurchasesReport.jsx";
import InstallmentsReport from "./screens/Reports/installments/InstallmentsReport.jsx";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }
  // return isAuthenticated ? children : <Navigate to="/unauthorized" />;
  return isAuthenticated ? children : <Navigate to="/signin" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <div className="content">
            <Routes>
              <Route path="/signin" element={<SignIn />} />
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Protected Routes */}
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>}>
                <Route index element={<Home />} />
                <Route path="suppliers" element={<ProtectedRoute><SuppliersListScreen /></ProtectedRoute>} />
                <Route path="suppliers/:id" element={<ProtectedRoute><Supplier /></ProtectedRoute>} />

                <Route path="/staff" element={<ProtectedRoute><StaffListScreen /></ProtectedRoute>} />
                <Route path="/staff/profile" element={<ProtectedRoute><StaffProfileScreen /></ProtectedRoute>} />
                <Route path="/staff/:id" element={<ProtectedRoute><StaffScreen /></ProtectedRoute>} />
                <Route path="/staff/:id/edit" element={<ProtectedRoute><StaffAddUpdate /></ProtectedRoute>} />
                <Route path="/staff/add" element={<ProtectedRoute><StaffAddUpdate /></ProtectedRoute>} />

                <Route path="/categories" element={<ProtectedRoute><CategoryScreen /></ProtectedRoute>} />
                <Route path="/products" element={<ProtectedRoute><ProductsListScreen /></ProtectedRoute>} />
                <Route path="/products/:id" element={<ProtectedRoute><ProductScreen /></ProtectedRoute>} />
                <Route path="/Customer/:id" element={<ProtectedRoute><CustomerScreen /></ProtectedRoute>} />
                <Route path="/customertypes" element={<ProtectedRoute><CustomerTypes /></ProtectedRoute>} />
                <Route path="/customers" element={<ProtectedRoute><CustomersListScreen /></ProtectedRoute>} />
                <Route path="fertilizers" element={<ProtectedRoute><Fertilizers /></ProtectedRoute>} />
                <Route path="expenses" element={<ProtectedRoute><Expense /></ProtectedRoute>} />
                {/* transactions */}
                <Route path="transactions/purchases" element={<ProtectedRoute><PurchasesScreen /></ProtectedRoute>} />
                <Route path="transactions/purchases/:id" element={<ProtectedRoute><PurchaseView /></ProtectedRoute>} />
                
                <Route path="transactions/sales" element={<ProtectedRoute><SalesScreen /></ProtectedRoute>} />
                <Route path="transactions/sales/:id" element={<ProtectedRoute><SaleView /></ProtectedRoute>} />

                <Route path="transactions/CustomerPaymentsDashboard" element={<ProtectedRoute><CustomerPaymentsDashboard /></ProtectedRoute>} />
                <Route path="transactions/SupplierPaymentsDashboard" element={<ProtectedRoute><SupplierPaymentsDashboard /></ProtectedRoute>} />
                <Route path="transactions/FertilizationTransactions" element={<ProtectedRoute><FertilizationTransactions /></ProtectedRoute>} />

                <Route path="transactions/expenses" element={<ProtectedRoute><ExpensesTransactions /></ProtectedRoute>} />
                <Route path="transactions/damages" element={<ProtectedRoute><DamagesTransactions /></ProtectedRoute>} />
                <Route path="transactions/damages/:id" element={<ProtectedRoute><DamageView /></ProtectedRoute>} />
                <Route path="transactions/cashhandovers" element={<ProtectedRoute><CashHandoversTransactions /></ProtectedRoute>} />
                {/* reports */}
                <Route path="Reports/ExpenseReport" element={<ProtectedRoute><ExpenseReport /></ProtectedRoute>} />
                <Route path="Reports/CashHandoverReport" element={<ProtectedRoute><CashHandoverReport /></ProtectedRoute>} />
                <Route path="Reports/FundSummaryReport" element={<ProtectedRoute><FundSummaryReport /></ProtectedRoute>} />
                <Route path="Reports/InventorySummaryReport" element={<ProtectedRoute><InventorySummaryReport /></ProtectedRoute>} />
                <Route path="Reports/FertilizationsReport" element={<ProtectedRoute><FertilizationsReport /></ProtectedRoute>} />
                <Route path="Reports/FertilizingDateReport" element={<ProtectedRoute><FertilizingDateReport /></ProtectedRoute>} />
                <Route path="Reports/MostSoldReport" element={<ProtectedRoute><MostSoldReport /></ProtectedRoute>} />
                <Route path="Reports/SuppliersAnalysisReport" element={<ProtectedRoute><SuppliersAnalysisReport /></ProtectedRoute>} />
                <Route path="Reports/DiscountsSavingsReport" element={<ProtectedRoute><DiscountsSavingsReport /></ProtectedRoute>} />
                <Route path="Reports/MostFrequentCustomersReport" element={<ProtectedRoute><MostFrequentCustomersReport /></ProtectedRoute>} />
                <Route path="Reports/sales & purchases/PurchasesReport" element={<ProtectedRoute><PurchasesReport /></ProtectedRoute>} />
                <Route path="Reports/installments/InstallmentsReport" element={<ProtectedRoute><InstallmentsReport /></ProtectedRoute>} />
                
              </Route>
            </Routes>
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
